var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9875 25.0453C44.4672 23.4039 42.3438 22.5 40 22.5C37.6438 22.5 35.5133 23.3984 34 25.0297C32.4703 26.6789 31.725 28.9203 31.9 31.3406C32.2469 36.1156 35.8805 40 40 40C44.1195 40 47.7469 36.1164 48.0992 31.3422C48.2766 28.9437 47.5266 26.707 45.9875 25.0453Z",
    fill: "#3671E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7499 57.5H26.2499C25.8899 57.5047 25.5335 57.4291 25.2064 57.2786C24.8794 57.1282 24.59 56.9068 24.3593 56.6305C23.8515 56.0234 23.6468 55.1945 23.7983 54.3562C24.4577 50.6984 26.5155 47.6258 29.7499 45.4687C32.6233 43.5539 36.2632 42.5 39.9999 42.5C43.7366 42.5 47.3765 43.5547 50.2499 45.4687C53.4843 47.625 55.5421 50.6977 56.2015 54.3555C56.353 55.1937 56.1483 56.0227 55.6405 56.6297C55.4099 56.9062 55.1205 57.1277 54.7935 57.2783C54.4664 57.4288 54.1099 57.5046 53.7499 57.5Z",
    fill: "#3671E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ad8a5db94be368b45b10954e70d38b4e.svg";
export { ForwardRef as ReactComponent };